import { API_LOCATION_URL } from 'infrastructure/config';
import { IAgentUserLogoutClient, IPostInput } from 'interfaceAdapter/gatewaySchemas/IAgentUserLogoutClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/user/logout`;

export class AgentUserLogoutClient implements IAgentUserLogoutClient {
    async post(input: IPostInput): Promise<void> {
        const { token } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        await fetch(PATH, { method, headers });
    }
}
